import { createStore } from 'vuex'

export default createStore({
	state: {
		loading :  true,
		language :  window.language ? window.language : 'it',
		localization : {},
		unit : window.creation ? window.creation.unit : window.language == 'en' ? 'inch' : 'cm',
		base_url : typeof api_url != 'undefined' ? api_url : process.env.VUE_APP_API_URL,
		bkg_colors: [
			{name:'Mapei 130', 		 rgb:'#F2E6D0'},
			{name:'Kerakoll KK 107', rgb:'#E0D8C5'},
			{name:'Mapei 114', 		 rgb:'#505455'},
			{name:'Kerakoll KK 72',  rgb:'#3F413A'},
			{name:'Mapei 168', 		 rgb:'#778FB1'},
			{name:'Kerakoll KK 26',  rgb:'#9DADB9'},
			{name:'Mapei 137', 		 rgb:'#CFC1AF'},
			{name:'Kerakoll KK 79',  rgb:'#C7BFAA'},
			{name:'Mapei 177', 		 rgb:'#8BA19E'},
			{name:'Kerakoll KK 55',  rgb:'#CED2BC'},
			{name:'Mapei 119', 		 rgb:'#70706E'},
			{name:'Kerakoll KK 10',  rgb:'#5C605E'},
			{name:'Mapei 145', 		 rgb:'#BB7B60'},
			{name:'Kerakoll KK 103', rgb:'#935233'},
			{name:'Mapei 189', 		 rgb:'#B29897'},
			{name:'Kerakoll KK 130', rgb:'#BB978B'},
			{name:'Mapei 143', 		 rgb:'#876156'},
			{name:'Kerakoll KK 114', rgb:'#9A4542'},
		],
		tiles : [],
		patterns : [],
		current_preset : null,
		base_tile : [34.7,34.7],
		gap : 0.1,
		background_color : '#F2E6D0',
		creation_data : window.creation ? JSON.parse(window.creation.creation_data) : null
	},
	mutations: {
		setPreset(state, value){
			state.current_preset = value;
		},
		setBackground(state, value){
			state.background_color = value;
		},
		setUnit(state, value){
			state.unit = value;
		},
		getData(state){
			
			fetch(state.base_url+'qzr-api/data')
				.then(response => {
					return response.json();
				})
				.then(data => {
					state.tiles = data.tiles;
					state.patterns = data.patterns;
					state.localization = data.localization;
					
					if(state.creation_data != null){
						let preset = state.patterns.find( p => p.ID == state.creation_data.pattern_id );
						if( preset ){
							this.commit('setPreset', preset);
							state.background_color = state.creation_data.background_color;
							state.current_preset.groups.forEach( (g,i) => {
								g.colors = state.creation_data.groups[i].colors;
								g.types = state.creation_data.groups[i].types;
							});
						}
					}
					
					state.loading = false;
				})
		},
	},
	actions: {
		initialize(context) {
			context.commit('getData', null);
		},
	},
})
